// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../../utils/CSS.bs.js";
import * as NavMenu__Link$Showside from "./NavMenu__Link.bs.js";
import * as NavMenu__Context$Showside from "./NavMenu__Context.bs.js";
import * as EntrypointContext$Showside from "../../context/EntrypointContext.bs.js";
function NavMenu__Breadcrumbs$Item(Props) {
  var category = Props.category;
  var index = Props.index;
  var path = Props.path;
  var match = EntrypointContext$Showside.use(undefined);
  var onPureCategoryClick = match.onPureCategoryClick;
  var isLast = (index + 1 | 0) === path.length;
  var isFirst = index === 0;
  var handleClick = isLast ? undefined : function (param) {
    Curry._2(onPureCategoryClick, undefined, category);
  };
  var tmp = {
    className: CSS$Showside.prefix(Cn.make(["flex text-primary", isLast ? "opacity-100" : "opacity-50 hover:opacity-75 cursor-pointer select-none"]))
  };
  if (handleClick !== undefined) {
    tmp.onClick = Caml_option.valFromOption(handleClick);
  }
  return React.createElement("div", tmp, isFirst ? null : React.createElement("div", {
    className: CSS$Showside.prefix("px-2")
  }, "/"), category.title);
}
NavMenu__Breadcrumbs$Item.displayName = "NavMenu__Breadcrumbs.Item";
var Item = {
  make: NavMenu__Breadcrumbs$Item
};
function NavMenu__Breadcrumbs(Props) {
  var path = Props.path;
  var layout = Props.layout;
  var link = Props.link;
  var classNameOpt = Props.className;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var ctx = NavMenu__Context$Showside.use(undefined);
  var padding;
  padding = layout.TAG === /* SliderLayout */0 ? layout._0.padding : layout._0.padding;
  var maxWidth;
  maxWidth = layout.TAG === /* SliderLayout */0 ? layout._0.maxWidth : layout._0.maxWidth;
  var match = ctx.mode;
  var paddingXCn = padding !== undefined ? "" : match ? "px-4" : "px-8";
  var tmp = {
    maxWidth: Belt_Option.mapWithDefault(maxWidth, "100%", CSS$Showside.intToPx)
  };
  var tmp$1 = Belt_Option.map(padding, CSS$Showside.intToPx);
  if (tmp$1 !== undefined) {
    tmp.paddingRight = tmp$1;
  }
  var tmp$2 = Belt_Option.map(padding, CSS$Showside.intToPx);
  if (tmp$2 !== undefined) {
    tmp.paddingLeft = tmp$2;
  }
  var style = tmp;
  var match$1 = ctx.mode;
  return React.createElement("div", {
    className: Cn.make([className, CSS$Showside.prefix(paddingXCn), CSS$Showside.prefix("flex items-center mx-auto pb-2")]),
    style: style
  }, React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make(["flex items-center font-medium", ctx.mode === /* Topbar */0 ? "text-2xl" : "text-xl flex-grow"]))
  }, match$1 ? Belt_Option.getWithDefault(Belt_Option.map(Belt_Array.get(path, path.length - 1 | 0), function (category) {
    return React.createElement(NavMenu__Breadcrumbs$Item, {
      category: category,
      index: 0,
      path: [category],
      key: category.id
    });
  }), null) : Belt_Array.mapWithIndex(path, function (i, category) {
    return React.createElement(NavMenu__Breadcrumbs$Item, {
      category: category,
      index: i,
      path: path,
      key: category.id
    });
  })), Belt_Option.mapWithDefault(link, null, function (link) {
    return React.createElement(NavMenu__Link$Showside.make, {
      link: link,
      className: CSS$Showside.prefix(Cn.make([ctx.mode === /* Topbar */0 ? "ml-6" : "ml-2"]))
    });
  }));
}
NavMenu__Breadcrumbs.displayName = "NavMenu__Breadcrumbs";
var make = React.memo(NavMenu__Breadcrumbs);
export { Item, make };
/* make Not a pure module */